import { useCallback, useEffect, useState } from "react";

import {
  AutonomousAgent,
  autonomousAgentService,
} from "services/autonomousAgentService";

/**
 * Loads the company's autonomous agents. The axios interceptor already fires an
 * error toast on failure; `error` here just drives the inline empty/error state.
 */
export function useAutonomousAgents() {
  const [agents, setAgents] = useState<AutonomousAgent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const data = await autonomousAgentService.getAll();
      setAgents(data);
      setError(null);
    } catch (err: any) {
      setError(err?.response?.data?.error ?? "load-failed");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { agents, loading, error, reload };
}
